import React, { useCallback, useEffect, useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import styled from 'styled-components';
import {
  Button,
  Tooltip as SuperopsTooltip,
  Modal,
  ButtonGroup,
  Page
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import {
  getTranslatedText,
  RunbookNodeActivatorContent,
  withErrorBoundary
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';
import ReplyContainer from '@nile/banyan/src/Containers/CascadeContainers/ReplyContainer';
import { isEmpty } from 'lodash';
import { TEMPLATE_TYPES } from '@nile/banyan/src/Constants/notifications';
// import SideConversationTemplateContainer from '@nile/banyan/src/Containers/ButtonContainers/SideConversationTemplateContainer.js';
// import ReplyTemplatePage from '@nile/banyan/src/Pages/Protected/Index/ReplyTemplatePage';

const Wrapper = styled.div`
  .Superops-Page--contentPrimary,
  [data-has-navigation] .Superops-Page--contentPrimary {
    padding: 0;
  }
`;

function SideConversationActionModal(props) {
  const { intl } = props;

  const saveLoading = false;

  const [allTemplates, setAllTemplates] = useState([]);
  const [selectedReplyTemplate, setSelectedReplyTemplate] = useState(null);

  const formData = props?.autoActionformData || props?.data?.formData || {};
  const actionValueData =
    props?.autoActionformData?.actionValueData || formData?.actionValueData;

  const parentActionId = formData?.parentActionId;
  const hasActionId = formData?.actionId;

  const [popoverActive, setPopoverActive] = useState(
    Boolean(!hasActionId || (props.isAutoAction && !props?.autoActionformData))
  );

  const showDeleteButton =
    (props.isAutoAction && props?.autoActionformData) ||
    (!props.isAutoAction && hasActionId);

  const togglePopoverActive = useCallback(() => {
    setPopoverActive((active) => !active);
  }, []);

  // const [
  //   isSideConversationTemplateOpen,
  //   setIsSideConversationTemplateOpen
  // ] = useState(false);

  // const toggleSideConversationTemplate = () => {
  //   setIsSideConversationTemplateOpen((prevState) => !prevState);
  // };

  const activator = (
    <RunbookNodeActivatorContent
      nodeType="admin.runbooks.templateactions.sideconversation"
      nodeName={
        selectedReplyTemplate?.name ||
        actionValueData?.notificationTemplate?.name
      }
      iconName="SideConversationColoured"
      callBackFunction={togglePopoverActive}
    />
  );

  useEffect(() => {
    if (!isEmpty(actionValueData) && allTemplates.length > 0) {
      const [foundTemplate] = allTemplates.filter(
        (task) => task.id === actionValueData.notificationTemplate?.id
      );
      setSelectedReplyTemplate(foundTemplate);
    }
  }, [allTemplates, popoverActive]);

  const onSave = () => {
    const formData = {
      name: selectedReplyTemplate?.name,
      actionType: 'SINGLE',
      actionProcessCategory: props?.isAutoAction ? 'ASYNC' : 'SYNC',
      actionValueType: 'SIDE_CONVERSATION',
      actionValueData: {
        nodeId: props.id,
        notificationTemplate: {
          id: selectedReplyTemplate?.id,
          name: selectedReplyTemplate?.name
        }
      }
    };
    if (hasActionId) {
      formData.actionId = hasActionId;
    }
    if (parentActionId) {
      formData.parentActionId = parentActionId;
    }

    if (props.isAutoAction) {
      props.autoActionSave(formData);
    } else {
      props.modifyNodeData(formData);
    }
    togglePopoverActive();
  };

  const updateSelectedReplyTemplate = (selectedTemplate) => {
    setSelectedReplyTemplate(selectedTemplate);
  };

  const handleNodeDelete = () => {
    setPopoverActive(false);

    if (props.isAutoAction) {
      props.handleAutoActionDelete(props.id);
    } else {
      props.data.handleNodeDelete(props.id, hasActionId);
    }
  };

  const handleNodeCancel = useCallback(() => {
    setPopoverActive(false);
    if (!props.isAutoAction && !hasActionId) {
      handleNodeDelete();
    } else if (props.isAutoAction && !props?.autoActionformData) {
      props.handleAutoActionDelete(props.id);
    }
  }, [hasActionId, handleNodeDelete]);

  return (
    <Modal
      large
      activator={activator}
      open={popoverActive}
      onClose={togglePopoverActive}
      showCloseButton={false}
      noScroll
    >
      <Page
        title={getTranslatedText(
          intl,
          'admin.runbooks.templateactions.sideconversation'
        )}
        contentHeight="110px"
        fullWidth
        variant="secondary"
        primaryAction={
          <ButtonGroup spacing="loose">
            {showDeleteButton && (
              <Button plainSecondary onClick={handleNodeDelete}>
                <div className="danger">
                  {getTranslatedText(intl, 'common.delete')}
                </div>
              </Button>
            )}

            {/* {!hasActionId && (
              <Button plainSecondary onClick={toggleSideConversationTemplate}>
                <FormattedMessage id="admin.taskTemplates.create" />
              </Button>
            )} */}

            <Button plainSecondary onClick={handleNodeCancel}>
              <FormattedMessage id="common.cancel" />
            </Button>

            <Button
              primary
              icon={<SVGIcon name="Save" />}
              onClick={() => {
                onSave();
              }}
              loading={saveLoading}
            >
              <FormattedMessage id="common.save" />
            </Button>
          </ButtonGroup>
        }
      >
        <Wrapper className="min-h80 mt-10">
          {/* <ReplyContainer
            selectedReplyTemplate={selectedReplyTemplate}
            updateSelectedReplyTemplate={updateSelectedReplyTemplate}
            cascadeOnly
            setAllTemplates={setAllTemplates}
            isRunbookTemplate
          /> */}
          {/* {!isSideConversationTemplateOpen && ( */}
          <ReplyContainer
            cascadeOnly
            variables={{
              notificationTemplateType: 'SIDE_CONVERSATION'
            }}
            deleteRoleToCheck={'sideConversationTemplate.delete'}
            editRoleToCheck={'sideConversationTemplate.edit'}
            templateType={TEMPLATE_TYPES.sideConversation}
            editComponent={() => {}}
            selectedReplyTemplate={selectedReplyTemplate}
            updateSelectedReplyTemplate={updateSelectedReplyTemplate}
            setAllTemplates={setAllTemplates}
            isRunbookTemplate
          />
          {/* )}
           
          {isSideConversationTemplateOpen && (
            <ReplyTemplatePage
              routeParams={{ type: 'new' }}
              type={'sideConversation'}
              onCancel={() => {
                setIsSideConversationTemplateOpen(false);
              }}
              isModal
              noPadding
              noMinWidth
            />
          )} */}
        </Wrapper>
      </Page>
    </Modal>
  );
}

export default withErrorBoundary(injectIntl(SideConversationActionModal));
